import AccountSvc from '../../api/AccountSvc';

const doGetUsers = async () => {
  try {
    const { data: localUsers } = await AccountSvc.getUsers();

    localUsers.sort((userA, userB) => {
      const { userRoles: userARoles } = userA;
      const [userARole] = userARoles;
      const { roleId: userARoleId } = userARole;

      const { userRoles: userBRoles } = userB;
      const [userBRole] = userBRoles;
      const { roleId: userBRoleId } = userBRole;

      return userARoleId - userBRoleId;
    });

    return localUsers.filter((user) => !user.expirationTime);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('exception getting users', e);
  }

  return [];
};

const SITE_OWNER = 1;
const ACCOUNT_MANAGER = 2;
const CAMPAIGN_CREATOR = 3;
const PARTNER_IMPERSONATION = 8;

const accountRoles = {
  SITE_OWNER,
  ACCOUNT_MANAGER,
  CAMPAIGN_CREATOR,
  PARTNER_IMPERSONATION,
};

const SSO_INVITE_TYPE = 'E';

export { accountRoles, SSO_INVITE_TYPE };

export default doGetUsers;
